import React, {useEffect} from "react";
import {Route, Switch, Redirect} from "react-router-dom";

// Hooks
import {useAuth} from "../auth/auth";
import useAppRoutes from "../common/hooks/use-app-routes";

// Components
import NotFoundPage from "../common/components/not-found-page";
import ForbiddenPage from "../common/components/forbidden-page";

// Libs
import {useUserClientsData} from "../user-clients-data/user-clients-data";

const PrivateAppRoutes = () => {
    const auth = useAuth();
    const routesMetaData = useAppRoutes();
    const userClientsData = useUserClientsData();

    useEffect(async () => await userClientsData.requestUserClientsData(), []);

    let redirectToNextFeature = [];
    if (auth.userType === "client") {

        auth?.features?.forEach(userFeature => {
            switch (userFeature) {
                case "invoices":
                    redirectToNextFeature.push("invoices");
                    break;
                case "delivery-notes":
                    redirectToNextFeature.push("delivery-notes");
                    break;
                case "stocks":
                    redirectToNextFeature.push("stocks");
                    break;
                case "services":
                    redirectToNextFeature.push("services");
                    break;
                case "technical-sheets":
                    redirectToNextFeature.push("technical-sheets");
                    break;
                case "transportation":
                    redirectToNextFeature.push("transportation");
                    break;
                default:
                    break;
            }
        });
    }

    return (
        <Switch>
            <Route exact path="/" render={() => (<Redirect to={routesMetaData[0].to}/>)} />
            {routesMetaData.map((routeMetaData, index) => {
                const feature = routeMetaData.to.substring(1);

                const checkShowStats = feature === "home" 
                    && !routeMetaData.isAdminRoute && auth.userType === "client" 
                    && (auth.features.indexOf("show-stats") >= 0);
                const noFeatures = !checkShowStats 
                    && (auth.features.indexOf("invoices") === -1) 
                    && (auth.features.indexOf("delivery-notes") === -1) 
                    && (auth.features.indexOf("stocks") === -1) 
                    && (auth.features.indexOf("technical-sheets") === -1) 
                    && (auth.features.indexOf("transportation") === -1);

                return (
                    <Route
                        key={index}
                        path={routeMetaData.to}
                        render={() => {
                            return (routeMetaData.isAdminRoute && auth.userType === "admin") || (!routeMetaData.isAdminRoute && auth.userType === "client" && (auth.features.indexOf(feature) >= 0)) || checkShowStats || (!routeMetaData.isAdminRoute && auth.userType === "admin") || noFeatures
                                ? (
                                    <routeMetaData.component />
                                )
                                : (!checkShowStats
                                        ? (
                                            <Redirect to={redirectToNextFeature[0] !== undefined ? redirectToNextFeature[0] : "home"}/>
                                        ) : (
                                            <ForbiddenPage/>
                                        )
                                );
                        }}
                    />
                );
            })}
            <Route
                render={() => {
                    return (
                        <NotFoundPage/>
                    );
                }}
            />
        </Switch>
    );
};

export default PrivateAppRoutes;